import React from "react";
import styled from "../styles";
import { StarIcon } from "./icons/StarIcon";

interface StarRatingProps {
  rating: number;
  maxRating?: number;
}

const StarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing.xxs};
`;

export const StarRating: React.FC<StarRatingProps> = ({ maxRating = 5 }) => {
  return (
    <StarContainer>
      {Array.from({ length: maxRating }).map((_, index) => (
        <StarIcon key={index} />
      ))}
    </StarContainer>
  );
};

export default StarRating;
